import { Grid, Tooltip, Typography } from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

function PageHeader() {
  return (
    <Grid container justifyContent="space-between" alignItems="center" mt={0.2}>
      <Grid item>
        <Typography variant="h2" component="h2" gutterBottom>
            <span style={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
              My Applications
              <Tooltip title="Users will receive warning emails when the number of similar crashes in their subscribed application exceeds the set threshold.">
              <HelpOutlineIcon fontSize="small" />
            </Tooltip>
            </span>
        </Typography>
      </Grid>
    </Grid>
  );
}

export default PageHeader;
